<template>
  <v-menu v-bind="$attrs" max-height="calc(100vh - 40px)" min-width="247">
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-list>
      <div v-for="item in items" :key="item.name">
        <v-list-item
          :data-test-action="item[itemKeyText].toLowerCase()"
          :disabled="!item._enabled"
          dense
          v-if="!item.divider"
          @click="handleClick(item)"
        >
          <v-list-item-icon v-if="item[itemKeyIcon]">
            <v-icon dense v-text="item[itemKeyIcon]"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ item[itemKeyText] }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon v-if="itemIdSelected === item[itemKeyText]">
            <v-icon color="primary" dense>mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider v-else />
      </div>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'DropdownMenu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    itemKeyValue: {
      type: String,
      default: 'id'
    },
    itemKeyText: {
      type: String,
      default: 'title'
    },
    itemKeyIcon: {
      type: String,
      default: 'icon'
    },
    itemIdSelected: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const handleClick = item => {
      if (item.handleAction) {
        item.handleAction();
      } else {
        emit('input', { raw: item, id: item[props.itemKeyValue] });
      }
    };

    return {
      handleClick
    };
  }
};
</script>
